import { buildTrendSeries, collectYears } from "features/energy-analysis-dashboard/lib/aggregate";
import type { EnergyAnalysisRow } from "features/energy-analysis-dashboard/model/types";

import type { CrremPathwayPartitionBy } from "../model/types";

import { CRREM_PATHWAY_PARTITION_BY } from "../model/constants";

export const buildPartitionedStacks = (rows: EnergyAnalysisRow[], partitionBy: CrremPathwayPartitionBy) => {
  if (partitionBy === CRREM_PATHWAY_PARTITION_BY.none) {
    return { series: [], years: collectYears(rows) };
  }
  return buildTrendSeries(rows, partitionBy);
};
